// extracted by mini-css-extract-plugin
export default {"varSpUp1":"1.25rem","var-in-desktop":"min-width: 768px","varInDesktop":"min-width: 768px","list":"list--3edae","single":"single--e8f38"};